// Mock data for Shire Advisors website

export const companyInfo = {
  name: "Shire Advisors, LLC",
  tagline: "Private and secure third party business analysis and financial consulting.",
  description: "Shire Advisors, LLC was formed to provide strategic consulting services, third party financial analysis and non-conventional financing to stagnant, underperforming or distressed small businesses and organizations.",
  phone: "(214) 673-2710",
  phoneAlt: "",
  email: "info@shireadvisors.com",
  address: "516 South I-35E, Denton, TX 76205",
  logo: "https://static.wixstatic.com/media/268b46_04730c0e0cca4c518a0c19d09963c8c8~mv2.jpg/v1/fill/w_1677,h_423,fp_0.50_0.40,q_85,enc_avif,quality_auto/268b46_04730c0e0cca4c518a0c19d09963c8c8~mv2.jpg"
};

export const services = [
  {
    id: 1,
    title: "Strategic Consulting",
    description: "Expert guidance to help your business navigate complex challenges and capitalize on growth opportunities. We develop actionable strategies tailored to your unique situation.",
    icon: "Target"
  },
  {
    id: 2,
    title: "Financial Analysis",
    description: "Comprehensive third-party financial analysis providing objective insights into your business performance, cash flow optimization, and financial health assessment.",
    icon: "BarChart3"
  },
  {
    id: 3,
    title: "Non-Conventional Financing",
    description: "Creative financing solutions for businesses that don't fit traditional lending criteria. We help secure the capital you need to grow or restructure.",
    icon: "Wallet"
  },
  {
    id: 4,
    title: "Blockchain Development",
    description: "Cutting-edge blockchain implementation and development services to modernize your business operations and secure your digital transactions.",
    icon: "Blocks"
  },
  {
    id: 5,
    title: "Bankruptcies & Workouts",
    description: "Structured bankruptcy planning and workout solutions to help distressed businesses reorganize, recover, and emerge stronger.",
    icon: "Scale"
  },
  {
    id: 6,
    title: "CRM/ERP Implementation",
    description: "Design and implementation of customer relationship management and enterprise resource planning systems to streamline your operations.",
    icon: "Settings"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Michael Richardson",
    role: "Managing Partner",
    bio: "25+ years of experience in corporate finance and strategic consulting. Former CFO of multiple Fortune 500 companies.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Sarah Chen",
    role: "Senior Financial Analyst",
    bio: "CPA with expertise in financial restructuring and business valuations. Helped over 200 businesses achieve financial stability.",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "David Thompson",
    role: "Blockchain & Technology Lead",
    bio: "Former tech executive with deep expertise in blockchain architecture and enterprise software implementation.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop"
  },
  {
    id: 4,
    name: "Jennifer Martinez",
    role: "Client Relations Director",
    bio: "Dedicated to ensuring every client receives personalized attention and achieves their business objectives.",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Shire Advisors helped us navigate a critical restructuring phase. Their strategic insights and hands-on approach saved our company.",
    author: "Robert Williams",
    company: "Williams Manufacturing Co.",
    rating: 5
  },
  {
    id: 2,
    quote: "The financial analysis provided by Shire was eye-opening. They identified inefficiencies we never knew existed and helped us increase profitability by 35%.",
    author: "Amanda Foster",
    company: "Foster Tech Solutions",
    rating: 5
  },
  {
    id: 3,
    quote: "Professional, discrete, and incredibly effective. Shire Advisors delivered exactly what they promised and more.",
    author: "James Mitchell",
    company: "Mitchell & Associates",
    rating: 5
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "Manufacturing Turnaround",
    industry: "Manufacturing",
    challenge: "A 50-year-old manufacturing company facing bankruptcy due to outdated processes and declining sales.",
    solution: "Implemented comprehensive restructuring, modernized operations, and secured non-traditional financing.",
    result: "Company returned to profitability within 18 months with 40% revenue growth.",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&h=400&fit=crop"
  },
  {
    id: 2,
    title: "Tech Startup Scaling",
    industry: "Technology",
    challenge: "Rapidly growing tech startup struggling with cash flow management and operational inefficiencies.",
    solution: "Designed and implemented ERP system, restructured finances, and developed growth strategy.",
    result: "Successfully scaled from $2M to $15M revenue in 3 years.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
  },
  {
    id: 3,
    title: "Retail Chain Restructuring",
    industry: "Retail",
    challenge: "Regional retail chain with 12 locations facing mounting debt and declining foot traffic.",
    solution: "Structured workout agreement with creditors, closed underperforming locations, pivoted to e-commerce.",
    result: "Reduced debt by 60% and achieved positive cash flow within 12 months.",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=600&h=400&fit=crop"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What types of businesses do you work with?",
    answer: "We specialize in working with small to mid-sized businesses that are stagnant, underperforming, or distressed. This includes manufacturing, retail, technology, and service-based businesses across various industries."
  },
  {
    id: 2,
    question: "How is Shire Advisors different from other consulting firms?",
    answer: "We provide truly independent, third-party analysis with no conflicts of interest. Our approach combines hands-on strategic guidance with access to non-conventional financing solutions that traditional consultants cannot offer."
  },
  {
    id: 3,
    question: "Is my business information kept confidential?",
    answer: "Absolutely. Confidentiality is paramount to our practice. All information shared with us is treated as strictly confidential and is never shared with third parties without explicit consent."
  },
  {
    id: 4,
    question: "What is non-conventional financing?",
    answer: "Non-conventional financing refers to funding sources outside traditional bank loans. This includes private equity, mezzanine financing, asset-based lending, and creative restructuring solutions tailored to businesses that may not qualify for traditional financing."
  },
  {
    id: 5,
    question: "How long does a typical engagement last?",
    answer: "Engagement length varies based on your needs. Initial assessments typically take 2-4 weeks, while comprehensive restructuring or implementation projects can span 6-18 months. We work with you to define clear milestones and timelines."
  },
  {
    id: 6,
    question: "Do you offer blockchain consulting for any industry?",
    answer: "Yes, our blockchain development and implementation services are available across industries. We help businesses leverage blockchain technology for supply chain management, smart contracts, secure transactions, and digital transformation initiatives."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "5 Warning Signs Your Business Needs Financial Restructuring",
    excerpt: "Learn to recognize the early indicators that suggest your business may benefit from professional financial restructuring services.",
    date: "August 15, 2025",
    category: "Financial Strategy",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop"
  },
  {
    id: 2,
    title: "How Blockchain is Transforming Small Business Operations",
    excerpt: "Discover the practical applications of blockchain technology that are helping small businesses improve efficiency and security.",
    date: "August 8, 2025",
    category: "Technology",
    image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=600&h=400&fit=crop"
  },
  {
    id: 3,
    title: "Navigating Business Challenges in an Uncertain Economy",
    excerpt: "Strategic insights for business owners looking to weather economic uncertainty and position their companies for growth.",
    date: "July 28, 2025",
    category: "Business Strategy",
    image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=400&fit=crop"
  }
];

export const stats = [
  { value: "200+", label: "Businesses Helped" },
  { value: "$500M+", label: "Capital Secured" },
  { value: "25+", label: "Years Experience" },
  { value: "95%", label: "Client Satisfaction" }
];
